import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {GenerateStoriesAiDialogModule} from '../editor-interface/dialogs/generate-stories-ai-dialog/generate-stories-ai-dialog.module';
import {MaterialModule} from '../material.module';
import {GraphActionsService} from './actions/graph-actions.service';
import {AttachmentsModule} from './attachments/attachments.module';
import {ContextMenuService} from './context-menu/context-menu.service';
import {GraphEventsHandlingService} from './graph-events-handler/graph-events-handling.service';
import {BoxHighlightService} from './services/box-highlight.service';
import {DragAssistService} from './services/drag-assist.service';
import {DrilldownService} from './services/drilldown.service';
import {RenumberService} from './services/renumber.service';
import {StickersService} from './services/stickers.service';
import {StyleClipboardService} from './services/style-clipboard.service';
import {SwimlanesService} from './services/swimlanes.service';
import {AddResourceDialogModule} from '../editor-interface/dialogs/add-resource-dialog/add-resource-dialog.module';
import {LinkedSFNodesService} from './services/linked-sf-nodes.service';
import {ContextBarService} from './context-bar/context-bar.service';
import {TextboxContextBar} from './context-bar/textbox/textbox-context-bar';
import {ActivityContextBar} from './context-bar/activity/activity-context-bar';
import {StickerContextBar} from './context-bar/sticker/sticker-context-bar';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    AttachmentsModule,
    TranslateModule,
    GenerateStoriesAiDialogModule,
    AddResourceDialogModule
  ],
  providers: [
    ContextMenuService,
    GraphActionsService,
    GraphEventsHandlingService,
    DrilldownService,
    RenumberService,
    DragAssistService,
    SwimlanesService,
    StickersService,
    StyleClipboardService,
    BoxHighlightService,
    LinkedSFNodesService,
    ContextBarService,
    TextboxContextBar,
    ActivityContextBar,
    StickerContextBar
  ]
})
export class DiagramInteractionModule {}
